import axios from '../js/ajax'

/** 获取下载页信息 */
export const getAllProductDetail = params => axios.get('/productV1/getAllProductDetail', {params});
/** 获取用户信息 */
export const getUserInfo = params => axios.get('/user/getUserMsgByInviteCode', {params});
/** 获取跳转链接 或者 跳转信息 */
export const getSkipInfo = params => axios.get('/product/getH5ProductPurchaseMsg', {params});
/*** 记录操作记录 */
export const recordHandle = params => axios.post('/record/recordUserOperation', params);
// 获取h5钱收收商品详情
export const getQssProductDetail = params => axios.get('/product/getQssProductDetail', {params});

